import React, {useState} from 'react'
import List from './List'
import EditEvUtility from './EditEvUtility'
export default function Main() {
    const [tab,setTab] =useState("list")

    const handlePage = (type)=>{
        setTab(type)
    }
  return (
    <>
    {
        tab === "list" ?
        <List handlePage={handlePage}/>
    :""}
    {
        tab === "edit" ?
        <EditEvUtility handlePage={handlePage}/>
    :""}
    </>
  )
}
